<div class="answer-generated__container">
    <img
        src="../../../../assets/icons/download-file-icon.svg"
        class="answer-generated__img"
        alt=""
    />
    <div class="answer-generated__title" [innerHTML]="title"></div>
    <div class="answer-generated__subtitle" [innerHTML]="subtitle"></div>
    <div class="answer-generated__buttons-container" *ngIf="buttons">
        <button
            class="answer-generated__button answer-generated__button--first"
            (click)="buttons.first.function()"
        >
            {{ buttons.first.label }}
        </button>
        <button
            *ngIf="buttons.second"
            class="answer-generated__button answer-generated__button--second"
            (click)="buttons.second.function()"
        >
            {{ buttons.second.label }}
        </button>
        <button
            *ngIf="buttons.third"
            class="answer-generated__button answer-generated__button--third"
            (click)="buttons.third.function()"
        >
            {{ buttons.third.label }}
        </button>
    </div>
    <mapp-legal-disclaimer></mapp-legal-disclaimer>
</div>
